// TODO: Finish format function
export const getFormattedAddress = (location) => {
  if (location && location.address) {
    return location.address.street + ' ' + location.address.number + ', ' + location.address.municipality 
  }
  return ""
}

export const getFormattedAdrWithApartment = (location) => {
  var res = ""
  if (location && location.address) {
    res = location.address.street + ' ' + location.address.number
    if(location.address.apartNumber) res += "- " + location.address.apartNumber
    res += ', ' + location.address.municipality 
  }
  return res
}



// WEBPACK FOOTER //
// ./src/listings/location/locationService.js